var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _rect, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFjLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 837.08 125.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#02bbba;}.cls-3{fill:#282a73;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "forward-justice-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.64,16.35V29h-16.4V55.27H182V67.89H166.24v39.56H152.31V16.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.82,108.23H211.4c-11.32,0-16.92-5.59-16.92-16.91V32.49c0-11.32,5.6-16.92,16.92-16.92h7.42c11.32,0,16.92,5.6,16.92,16.92V91.32C235.74,102.64,230.14,108.23,218.82,108.23Zm-2.21-80.42h-2.87c-3.64,0-5.33,1.69-5.33,5.33V90.66c0,3.65,1.69,5.34,5.33,5.34h2.87c3.51,0,5.2-1.69,5.2-5.34V33.14C221.81,29.5,220.12,27.81,216.61,27.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.84,76.48v31H274.92V76.74c0-4-1.82-5.86-5.86-5.86h-6.25v36.57H248.89V16.35h22.9c11.33,0,16.92,5.6,16.92,16.92V50.45c0,8.07-2.86,12-7.94,14.06C286.5,66.07,288.84,69.58,288.84,76.48ZM269.58,28.72h-6.77V58.78h6.25c3.9,0,5.73-1.82,5.73-5.6V33.92C274.79,30.41,273.1,28.72,269.58,28.72Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.76,81.3l6.51-64.95H366L355,107.45h-16.4l-6.25-54.92-6,54.92H309.8l-11.06-91.1h14.05L319.3,81.3l7-64.95h13.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M415.87,107.45h-13.8l-1.82-14.31H385.81l-1.7,14.31H371.23l13-91.23h18.48Zm-28.5-26.68h11.32L393,34.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M466.76,76.48v31H452.83V76.74c0-4-1.82-5.86-5.85-5.86h-6.25v36.57H426.8V16.35h22.91c11.32,0,16.92,5.6,16.92,16.92V50.45c0,8.07-2.87,12-7.94,14.06C464.42,66.07,466.76,69.58,466.76,76.48ZM447.5,28.72h-6.77V58.78H447c3.9,0,5.72-1.82,5.72-5.6V33.92C452.7,30.41,451,28.72,447.5,28.72Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480,16.35H501c13.54,0,19.91,6.51,19.91,19.91V87.54c0,13.41-6.37,19.91-19.91,19.91H480ZM494,95.22H499c5.46,0,7.94-2.6,7.94-8.07V36.66c0-5.47-2.48-8.07-7.94-8.07H494Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M561.26,90.79c0,11.33-5.6,16.92-16.92,16.92H538V98.08h5.73c4.81,0,7.16-2.34,7.16-7.16V16.61h10.41Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M613.06,91.58c0,11.32-5.6,16.91-16.92,16.91h-3.25c-11.33,0-16.92-5.59-16.92-16.91v-75h10.41V92.1c0,4.68,2.21,6.89,6.9,6.89h2.47c4.68,0,6.9-2.21,6.9-6.89V16.61h10.41Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M664.08,78.3V91.58c0,11.32-5.6,16.91-16.92,16.91H644.3c-11.2,0-16.66-5.59-16.66-16.66V72.7h10.15V92.23c0,4.68,2.21,6.89,6.9,6.89h2.08c4.68,0,6.89-2.21,6.89-6.89V78.56c0-4.55-1.56-6.51-4.55-8.72L636.36,60.6c-6.77-4.81-8.72-9.5-8.72-16.92V32.75c0-11.32,5.59-16.92,16.92-16.92h2.6c11.19,0,16.66,5.6,16.66,16.66v16.4H653.66V32.1c0-4.69-2.21-6.9-6.89-6.9H645c-4.69,0-6.9,2.21-6.9,6.9V43.55c0,4.56,1.69,6.51,4.68,8.72l12.63,9.11C662,66.2,664.08,70.49,664.08,78.3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M687.25,107.71V26.24H673.58V16.61h37.74v9.63H697.66v81.47Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M733.32,107.71H722.91V16.61h10.41Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M785.51,72.7V91.58c0,11.32-5.6,16.91-16.92,16.91H765.2c-11.32,0-16.91-5.59-16.91-16.91V32.75c0-11.32,5.59-16.92,16.91-16.92h3.39c11.19,0,16.66,5.47,16.66,16.66v16.4H775.1V32.23c0-4.68-2.22-6.9-6.9-6.9h-2.6c-4.69,0-6.9,2.22-6.9,6.9V92.1c0,4.68,2.21,6.89,6.9,6.89h2.86c4.68,0,6.9-2.21,6.9-6.89V72.7Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M828.46,16.61v9.63H810.24v30.2h17.57v9.5H810.24V98.08h18.48v9.63H799.83V16.61Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.82 35.63 90.45 63 90.45 35.63 117.82 35.63"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.82 90.36 90.45 90.36 90.45 63 117.82 90.36"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.45 90.36 90.45 117.73 63.09 90.36 90.45 90.36"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "90.45 63 90.45 90.36 63.09 90.36 90.45 63"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "90.45 35.63 90.45 63 63.09 35.63 90.45 35.63"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.45 8.27 90.45 35.63 63.09 35.63 90.45 8.27"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.74,
    y: 43.65,
    width: 38.7,
    height: 38.7,
    transform: "translate(-26.07 63.06) rotate(-45)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.09 35.63 35.72 63 35.72 35.63 63.09 35.63"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.09 90.36 35.72 117.73 35.72 90.36 63.09 90.36"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.09 35.63 35.72 35.63 35.72 8.27 63.09 35.63"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.09 90.36 35.72 90.36 35.72 63 63.09 90.36"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.72 63 35.72 90.36 8.36 90.36 35.72 63"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.72 35.63 35.72 63 8.36 35.63 35.72 35.63"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFjLogo);
export default __webpack_public_path__ + "static/media/FJ-logo.a86bea0ce3ce1d3202b13e50505f5cba.svg";
export { ForwardRef as ReactComponent };